<template>
  <div class="solicitarSenha">
    <div class="container">
      <v-snackbar v-model="loginSuccess" color="success" top :timeout="8000" multi-line>
        <p>Alteração efetuada com sucesso! Instruções foram enviadas com sucesso para {{ emailCadastrado }}.</p>
        <v-btn color="info" @click="loginSuccess=false">Ok</v-btn>
      </v-snackbar>

      <v-snackbar color="error" v-model="loginFail" top :timeout="8000">
        <span>Nenhum cadastro encontrado para este CPF/CNPJ! Verifique os campos informados e tente novamente.</span>
        <v-btn color="info" @click="loginFail=false">Fechar</v-btn>
      </v-snackbar>

      <h1 class="display-1 primary--text my-3">Recuperar Senha</h1>
      <v-divider></v-divider>
      <v-row wrap justify="center">
        <v-flex xs12 sm6 lg4>
          <v-card hover class="ma-4">
            <v-card-title>Redefinir senha</v-card-title>
            <v-card-text>
              <span
                  class="body-2"
              >Informe seu {{ getLabelCpfCnpj }} abaixo e enviaremos um e-mail contendo um link para definir uma nova senha.</span>

              <v-form ref="form" class="my-3">
<!--                <v-text-field-->
<!--                    v-mask="['###.###.###-##', '##.###.###/####-##']"-->
<!--                    v-model="cpfCnpj"-->
<!--                    :rules="regrasObrigacao"-->
<!--                    label="CPF/CNPJ"-->
<!--                    required-->
<!--                    clearable-->
<!--                    prepend-icon="account_circle"></v-text-field>-->

                <v-text-field
                    v-if="cpf && !cnpj"
                    v-mask="['###.###.###-##']"
                    @blur="ajustaCpf"
                    v-model="cpfCnpj"
                    :rules="regrasObrigacao"
                    :label="getLabelCpfCnpj"
                    required
                    clearable
                    prepend-icon="account_circle">
                </v-text-field>

                <v-text-field
                    v-if="cnpj && !cpf"
                    v-mask="['##.###.###/####-##']"
                    @blur="ajustaCnpj"
                    v-model="cpfCnpj"
                    :rules="regrasObrigacao"
                    :label="getLabelCpfCnpj"
                    required
                    clearable
                    prepend-icon="account_circle">
                </v-text-field>

                <v-text-field
                    v-if="cpf && cnpj"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    v-model="cpfCnpj"
                    :rules="regrasObrigacao"
                    :label="getLabelCpfCnpj"
                    required
                    clearable
                    prepend-icon="account_circle">
                </v-text-field>



              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
<!--              <v-btn color="info" outlined small type="submit" router to="RecuperarEmail">-->
<!--                <v-icon small left>history</v-icon>-->
<!--                <span>Recuperar e-mail</span>-->
<!--              </v-btn>-->
              <v-spacer></v-spacer>
              <v-btn small color="primary" type="submit" @click="recuperarSenha">
                <v-icon left>send</v-icon>
                <span>Enviar senha</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mask} from "vue-the-mask";
import {base_url} from "../global";
import CpfCnpjMixin from "@/mixins/CpfCnpjMixin";

export default {
  directives: {mask},
  mixins: [CpfCnpjMixin],
  data() {
    return {
      cpf: false,
      cnpj: false,
      cpfCnpj: null,
      loginSuccess: false,
      loginFail: false,
      emailCadastrado: "",
      regrasObrigacao: [v => !!v || "Campo obrigatório!"]
    };
  },
  methods: {
    recuperarSenha() {
      axios.defaults.baseURL = `${base_url}/notafiscal-ws/servico/acesso/esqueceusenha/sistema/NOTAFISCAL_EXTERNO`;

      // console.log(axios.defaults.baseURL);

      if (!this.$refs.form.validate()) {
        // console.log("Erro!");
      } else {
        this.cpfCnpj = this.removeMask();
        axios
            .put(`/login/${this.cpfCnpj}`)
            .then(res => {
              this.emailCadastrado = res.data;
              // console.log(this.emailCadastrado);
              this.loginSuccess = true;
            })
        // .catch(error => {
        // console.log(error);
        // this.loginFail = true;
        // });
      }
    },
    removeMask() {
      return this.cpfCnpj.replace(/[^a-zA-Z0-9]/g, "");
    }
  },
  computed: {
    getLabelCpfCnpj() {

      if (this.cpf && this.cnpj)
        return "CPF/CNPJ";
      else if (this.cpf)
        return "CPF";
      else if (this.cnpj)
        return "CNPJ";
      else
        return "";
    },
  },
  mounted() {
    this.cpf = this.$route.params.cpf;
    this.cnpj = this.$route.params.cnpj;
    this.permiteRedefinicaoEmail = this.$route.params.permiteRedefinicaoEmail;
  }
};
</script>

<style scoped>
</style>
